import { render, staticRenderFns } from "./specialization.vue?vue&type=template&id=7f77ba90"
import script from "./specialization.vue?vue&type=script&lang=js"
export * from "./specialization.vue?vue&type=script&lang=js"
import style0 from "./specialization.vue?vue&type=style&index=0&id=7f77ba90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports